import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const DeleteVideoTutorialCategorySlice = createSlice({
    name: "DeleteVideoTutorialCategorySlice",
    initialState: {} as IReduxState<any>,
    reducers: {
        deleteVideoTutorialCategory: (state, action) => {
            state.isLoading = true;
        },
        successdeleteVideoTutorialCategory: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failuredeleteVideoTutorialCategory: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearDeleteVideoTutorialCategoryResponse: (state) => {
            state.data = {};
        },
    },
});

export const {
    deleteVideoTutorialCategory,
    successdeleteVideoTutorialCategory,
    failuredeleteVideoTutorialCategory,
    clearDeleteVideoTutorialCategoryResponse,
} = DeleteVideoTutorialCategorySlice.actions;

export default DeleteVideoTutorialCategorySlice.reducer;
